module.exports = __webpack_public_path__ + "static/media/gram3.6e0d733a.jpg";